/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 0c4163b8e5ca
 */

import * as z from "zod";
import {
  StructuredMetadataValue,
  StructuredMetadataValue$zodSchema,
} from "./structuredmetadatavalue.js";

/**
 * A pipe-separated list or a map of custom metadata fields (by external_id) and the values to assign to each of them. The = " and | characters can be supported as values when escaped with a prepended backslash (\). For a multi-select field, you can set a maximum of 3000 different metadata values on an asset.
 *
 * @remarks
 */
export type StructuredMetadataParam = string | {
  [k: string]: StructuredMetadataValue;
};

export const StructuredMetadataParam$zodSchema: z.ZodType<
  StructuredMetadataParam
> = z.union([
  z.string(),
  z.record(z.string(), StructuredMetadataValue$zodSchema),
]).describe(
  "A pipe-separated list or a map of custom metadata fields (by external_id) and the values to assign to each of them. The = \" and | characters can be supported as values when escaped with a prepended backslash (\\). For a multi-select field, you can set a maximum of 3000 different metadata values on an asset.\n",
);
